/**
* @ngdoc directive
* @name Panel Scroll
*
* @description
  Scroll top when user opens new panel.
  Go to the previous window position when user closes new panel and goes to previous
*
* @scope
* @param {Boolean} ngIf - used to catch initial panel hide / show event
* @param {Boolean} ngShow - same
*/

(function () {
  directive.$inject = ["panelScrollService"];
  app.directive('panelScroll', directive);

  function directive(panelScrollService) {
    return {
      restrict: 'A',
      scope: {
        ngIf: '&?',
        ngShow: '&?'
      },
      link: link,
      priority: 601 // ngIf/ngShow priority + 1 to execute directive before
    };

    function link($scope, $element, $attributes) {
      var valueToMonitor = $attributes.ngIf ? 'ngIf' : 'ngShow';

      $scope.$watch(function () {
        if ($scope[valueToMonitor]) {
          return $scope[valueToMonitor]();
        }
      }, function (newValue, oldValue) {
        // do not do anything on init
        if (newValue === oldValue) return;

        if (newValue) {
          panelScrollService.scrollToSaved();
        } else {
          panelScrollService.saveAndUp();
        }
      });
    }
  }
}());




// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/panelScroll/directive.js